import { useCallback, useRef, useState } from 'react';

export const useCaptcha = () => {
  const [captchaToken, setCaptchaToken] = useState(null);
  const [loading, setLoading] = useState(true);

  const captchaRef = useRef(null);

  const onResolved = useCallback(token => {
    setCaptchaToken(token);
  }, []);

  const onExpired = useCallback(() => {
    setCaptchaToken(null);
  }, []);

  const onLoaded = useCallback(() => {
    setTimeout(() => setLoading(false), 1000);
  }, []);

  const reset = useCallback(() => {
    if (captchaRef.current) {
      captchaRef.current.reset();
    }
    setCaptchaToken(null);
  }, []);

  const isValidCaptcha =
    !loading && captchaToken && captchaToken !== 'disable-captcha-validation';

  return {
    captchaToken,
    loading,
    captchaRef,
    isValidCaptcha,
    handlers: {
      onResolved,
      onExpired,
      onLoaded,
      reset
    }
  };
};
